import styles from '../styles.module.css'

export default function outOfStock(props) {
  const {isOutOfStock} = props.product
  if (!isOutOfStock) return
  return <div className={styles.outOfStock}>{props.t('fields.outOfStock', {ns: 'generic'})}</div>
}
